// extracted by mini-css-extract-plugin
export default {"container":"dynamicPageLoader__container__E6OvT","component":"dynamicPageLoader__component__rU5NX","active":"dynamicPageLoader__active__oZ87G"};